module.exports = __webpack_public_path__ + "assets/retina_ParallelogramBy3MidpointsDetailed.e5a9057e4a0833cad781749967c68da1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_ParallelogramBy3MidpointsDetailed.png
// module id = 700
// module chunks = 0